import { Record } from 'immutable'

const AccountRangeValue = Record({
  rowid: '',
  startAccount: '',
  endAccount: '',
})

export default AccountRangeValue
